import { Fragment, type FC } from 'react';

import { MainPageHeader } from '#packages/web/layouts/page/header';
import { PageContent } from '#packages/web/layouts/page/page-content';
import type { WithViewModelProps } from '#packages/web/types/view-model-props';

import { UserSettingsForm } from '../../components/user-settings-form';

import {
  useUserSettingsPageViewModel,
  type UserSettingsPageViewModel,
} from './view-model';

export type UserSettingsPageProps = WithViewModelProps<UserSettingsPageViewModel>;

export const UserSettingsPage: FC<UserSettingsPageProps> = ({
  viewModel: { drawer, form, isReady },
}: UserSettingsPageProps) => (
  <Fragment>
    <MainPageHeader title="Settings" onNavigationIconClick={drawer.open} />

    <PageContent maxWidth="sm">
      {isReady && <UserSettingsForm form={form} />}
    </PageContent>
  </Fragment>
);

export const withViewModel = () => (
  <UserSettingsPage viewModel={useUserSettingsPageViewModel()} />
);

export default withViewModel;
